import statsEliteMark from '../../assets/brand/stats-elite-mark-transparent.png';

function StatsEliteLogo({
    markSize = 64,
    wordSize = 34,
    gap = 12,
    taglineSize = Math.max(10, Math.round(wordSize * 0.34)),
    tagline = 'We bring your data to life',
    style = {}
}) {
    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap,
                lineHeight: 1,
                ...style
            }}
        >
            <img
                src={statsEliteMark}
                alt=""
                aria-hidden="true"
                width={markSize}
                height={markSize}
                style={{ display: 'block', width: markSize, height: markSize, objectFit: 'contain' }}
            />
            <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span
                    style={{
                        color: '#62B6E8',
                        fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
                        fontSize: wordSize,
                        fontWeight: 800,
                        letterSpacing: '3px',
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                        textTransform: 'uppercase'
                    }}
                >
                    STATS ELITE
                </span>
                <span
                    style={{
                        color: '#2F7FAE',
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: taglineSize,
                        fontStyle: 'italic',
                        lineHeight: 1.25,
                        marginTop: Math.max(3, Math.round(wordSize * 0.18)),
                        whiteSpace: 'nowrap'
                    }}
                >
                    {tagline}
                </span>
            </span>
        </span>
    );
}

export default StatsEliteLogo;
